module.exports = __webpack_public_path__ + "ccde41ca646256fa551e5dc3495f7d25.jpg";